module.exports = __webpack_public_path__ + "static/media/bcp.7c0e8f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/features/bcp.png
// module id = 1575
// module chunks = 0